import { Autocomplete, TextField } from '@mui/material'
import { FC, useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../hooks'
import { Challan } from 'src/services'
import { fetchChallansAction, fetchChallansResetAction } from '../../../store/slips'
import { showAlertAction } from '../../../store/alerts'

export interface ChallanDropDownProps {
  accountId: number
  onChallanChange: (challan: any) => void
  challanNo?: string
  /** When set, prefer matching list row by id (disambiguates duplicate slip numbers across FY). */
  initialChallanId?: number
  error?: boolean
  challan_type?: string
}

function resolveInitialChallan(
  list: Challan[],
  initialChallanId?: number,
  challanNo?: string
): Challan | undefined {
  if (initialChallanId != null && initialChallanId > 0) {
    const byId = list.find((c) => c.id === initialChallanId)
    if (byId) return byId
  }
  if (challanNo != null && challanNo !== '') {
    const byNo = list.find((element) => element.slipNo === challanNo)
    if (byNo) return byNo
  }
  const hasHint =
    (challanNo != null && challanNo !== '') ||
    (initialChallanId != null && initialChallanId > 0)
  if (!hasHint && list.length > 0) {
    return list[0]
  }
  return undefined
}

export const ChallanDropDown: FC<ChallanDropDownProps> = ({
  accountId,
  onChallanChange,
  challanNo,
  initialChallanId,
  error,
  challan_type,
}) => {
  const dispatchAction = useAppDispatch()
  const [selectedChallan, setSelectedChallan] = useState<any | null>(null)
  const [challans, setChallans] = useState<Challan[]>([])
  
  const {
    data: challansData,
    success: challansSuccess,
    message: challansError,
  } = useAppSelector((state) => state.fetchChallan)

  const defaultProps = {
    options: challans,
    getOptionLabel: (option: Challan) => option.label,
  }

  useEffect(() => {
    dispatchAction(fetchChallansAction(accountId, challan_type))
  }, [accountId, challan_type])

  useEffect(() => {
    if (challansSuccess && challansData) {
      setChallans(challansData)

      const challan = resolveInitialChallan(
        challansData,
        initialChallanId,
        challanNo
      )
      setSelectedChallan(challan)
      onChallanChange(challan)
      dispatchAction(fetchChallansResetAction())
    } else if (challansError && !challansSuccess) {
      dispatchAction(
        showAlertAction({ message: challansError, severity: 'error' })
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- onChallanChange is stable enough; avoid re-firing parent setState loops
  }, [challansSuccess, challansError, challanNo, initialChallanId])

  return (
    <Autocomplete
                  size='small'           
      {...defaultProps}
      id="select-challan"
      value={selectedChallan}
      options={challans}
      onChange={(e, newValue) => {
        setSelectedChallan(newValue)
        onChallanChange(newValue)
      }}
      renderInput={(params) => (
        <TextField
                    size='small'
          {...params}
          error={error}
          label={'Select Challan'}
          sx={{ minWidth: '100%' }}
        />
      )}
    />
  )
}
